import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { Paper } from '@shared/components';
import { AssortmentPricesContainer } from '@retail/my-assortment/containers';

export function BaseAssortmentPage() {
  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper sx={{ display: 'flex', flexDirection: 'column', p: 0, height: '100%' }}>
        <SuspenseWithSentryErrorBoundary>
          <AssortmentPricesContainer />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
}
